import React, { useState } from 'react';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import IconItem from 'components/common/icon/IconItem';
import axios from 'helpers/api';
import { useEffect } from 'react'
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Col } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';

const MedAmountTable = (props) => {

    function handleEditInput(editValue) {
        //console.log("I m in Handle Edit " + editValue);
        props.onCallEditParent(editValue);
    }

    const columns = [
        {
            accessorKey: 'amount',
            header: 'Amount',
            meta: {
                headerProps: { className: 'pe-1 col-lg-4 text-start text-900' }
            }
        },
        // {
        //     accessorKey: 'updated_by',
        //     header: 'Updated By',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        // {
        //     accessorKey: 'updatedate',
        //     header: 'Updated Date',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        {
            accessorKey: 'Action',
            header: '',
            meta: {
                headerProps: {
                    className: 'text-900'
                },
                cellProps: {
                    className: 'align-items-center'
                }
            },
            enableSorting: false,
            cell: ({ row: { original } }) => {
                return <IconItem
                    tag="button"
                    icon={['far', 'edit']}
                    size="sm"
                    onClick={() => handleEditInput({
                        amount: original.amount,
                        is_active: original.is_active,
                        medamount_id: original.medamount_id
                    })}
                    className="btn rounded-3 me-2 fs-11 align-items-center"
                />
            }
        }
    ];

    const [medAmount, setMedAmount] = useState([]);
    const [error, setError] = useState(true);
    // const [showModal, setShowModal] = useState(false);

    // const handleEditMedAmountModal = (amountValue, isActive, amountId) => {
    //     //console.log("Trager" + event.target.id);
    //     //formName = event.target.id;
    //     //setFormNameModal(event.target.id);
    //     localStorage.setItem("amountValue", amountValue);
    //     localStorage.setItem("amountId", amountId);
    //     localStorage.setItem("isActive", isActive);
    //     setShowModal(true);
    // };

    useEffect(() => {

        async function fetchMedAmount() {

            let tokenStr = localStorage.getItem("accessToken");

            const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/drugs/get-drug-amount", { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            const results = []
            const drugAmtData = data.data

            if (data.status) {
                drugAmtData.forEach((value) => {
                    let active_sts = value.is_active ? "active" : "inactive";
                    if (props.active_status == active_sts) {
                        results.push({
                            amount: value.amount,
                            medamount_id: value.id,
                            is_active: value.is_active// == 1 ? 0 : 1
                            // updated_by: value.updated_by,
                            // updatedate: value.updated != null ? moment(value.updated, 'YYYY-MM-DD').format('MM/DD/YY') : null
                        });
                    }
                });

                if (results.length > 0) {
                    setMedAmount(results);
                    setError(true)
                } else {
                    setError(false)
                }
            }
            else {
                toast.info("No MedAmount found in this list");
            }
        }

        fetchMedAmount();

        async function refreshMedAmtDetails() {
            fetchMedAmount();
        }

        if (props.trigger > 0) {
            //console.log(props.trigger);
            refreshMedAmtDetails();
        }

    }, [props.trigger]);

    const table = useAdvanceTable({
        data: medAmount,
        columns,
        selection: false,
        sortable: true,
        pagination: true,
    });

    return (
        <div>
            <AdvanceTableProvider {...table}>
                <Col xs="4" className="mb-3 ms-auto">
                    <AdvanceTableSearchBox placeholder="Search..." />
                </Col>
                {error ? <AdvanceTable
                    headerClassName="bg-200 text-nowrap align-middle text-center"
                    rowClassName="text-nowrap align-middle "//text-center
                    tableProps={{
                        size: 'lg',
                        striped: true,
                        className: 'fs-10 mb-0'
                    }}
                /> : <div className="d-flex justify-content-center align-items-center text-center" style={{ height: '50px' }}>
                    <p className="text-danger fw-bold mb-0">There is no data available in the table</p>
                </div>}
                <div className="mt-3">
                    <AdvanceTableFooter
                        rowInfo
                        navButtons
                        rowsPerPageSelection
                    />
                </div>
            </AdvanceTableProvider>
            {/* <EditMedAmountModal show={showModal} setShow={setShowModal} /> */}
        </div>
    );
};

export default MedAmountTable;

